import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FooterSEOContent } from "@faire/retailer-visitor-shared/components/Footer/FooterSEOContent";
import { getSettingRetailerShowFooterContactUs } from "@faire/retailer-visitor-shared/settings/getSettingRetailerShowFooterContactUs";
import { AwardsModule } from "@faire/retailer-visitor-shared/views/about/components/AwardsModule";
import { CompanyValuesAndOfficesModule } from "@faire/retailer-visitor-shared/views/about/components/CompanyValuesAndOfficesModule";
import { ContactModule } from "@faire/retailer-visitor-shared/views/about/components/ContactModule";
import { HeaderModule } from "@faire/retailer-visitor-shared/views/about/components/HeaderModule";
import { HeroModule } from "@faire/retailer-visitor-shared/views/about/components/HeroModule";
import { ImageModule } from "@faire/retailer-visitor-shared/views/about/components/ImageModule";
import { NumberModule } from "@faire/retailer-visitor-shared/views/about/components/NumberModule";
import { Column } from "@faire/web--source/slate/Layout";
import React from "react";
export var About = function() {
    return /*#__PURE__*/ _jsxs(Column, {
        children: [
            /*#__PURE__*/ _jsx(HeaderModule, {}),
            /*#__PURE__*/ _jsx(ImageModule, {}),
            /*#__PURE__*/ _jsx(NumberModule, {}),
            /*#__PURE__*/ _jsx(HeroModule, {}),
            /*#__PURE__*/ _jsx(CompanyValuesAndOfficesModule, {}),
            /*#__PURE__*/ _jsx(AwardsModule, {}),
            getSettingRetailerShowFooterContactUs() ? /*#__PURE__*/ _jsx(ContactModule, {}) : null,
            /*#__PURE__*/ _jsx(FooterSEOContent, {})
        ]
    });
};
